import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [

  {
    path: '/',
    name: '/',
    component: () => import('@/views/index'),
  },
  {
    path: '/index',
    name: '/index',
    component: () => import('@/views/index'),
  },
  
  {
    path: '/about_us',
    name: 'about_us',
    component: () => import('@/views/about_us'),
  },
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: () => import('@/views/privacypolicy'),
  }

 

]
const createRouter = () => new Router({
  mode: 'history', // require service support
  routes: constantRoutes,
  scrollBehavior(to, from, savePosition) { //eslint-disable-line
    if (savePosition) return savePosition;
    else return { x: 0, y: 0 }
  }
})
const router = createRouter()

export default router



// WEBPACK FOOTER //
// ./src/router/index.js